'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var sidePanel = require('./side-panel');
var dataMgr = require('./data-mgr');

var state;

var saveComment = function() {

	var $btn = $(this);
	var $commentForm = $('.comment-form');

	$btn.text(window.pbizServer.content.loading);

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=save_comment',
		dataType: 'JSON',
		data: $commentForm.serialize()

	}).done(function(response) {

		// broadcast response event for other modules
		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var updateCommentCount = function() {

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=get_comment_count',
		dataType: 'JSON'

	}).done(function(response) {

		// broadcast response event for other modules
		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var loadComments = function(data) {

	$.ajax({

		type: 'POST',
		url: dataMgr.getEventUrl() + '?page=load_comments',
		dataType: 'JSON',
		data: data

	}).done(function(response) {

		// broadcast response event for other modules
		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	});

};

var renderComments = function(content) {

	sidePanel.open(content, {type: 'comments'});

};

var addEventHandlers = function() {

	appDom.document.on('main_nav_opened.comments', function() {

		updateCommentCount();

	});

	appDom.document.on('slideshow_comment_btn_clicked.comments main_nav_comments_clicked.comments', function(e) {

		if (e.type === 'slideshow_comment_btn_clicked') {

			state.pendingData.photoId = dataMgr.getImageMeta().photoId;

		} else {

			// No specific photo information should be used when commenting from the menu.
			state.pendingData = {};

		}

		loadComments(state.pendingData);

	});

	appDom.document.on('load_comments.comments comment_saved', function() {

		loadComments(state.pendingData);

	});

	appDom.document.on('comments_loaded', function(e, data) {

		renderComments(data.response.markup);

	});

	appDom.document.on('click', '.comment-form__submit-button', saveComment);

	appDom.document.on('comment_invalid_message', function(e, data) {

		var $msg = $('.comment-form__textarea');
		var $btn = $('.comment-form__submit-button');

		$btn.text('send');

		notify.show({
			target: $msg,
			container: '.comment-form',
			msg: data.response.status.msg
		});

	});

};

var setupInitialState = function() {

	state = {
		pendingData: {}
	};

};

var init = function() {

	setupInitialState();
	addEventHandlers();

};

module.exports = {
	init: init
};
